import { queryOptions, UseQueryOptions } from "@tanstack/react-query";
import { fetchAllPaginatedGraphQl } from "./fetchAllPaginatedGraphQl";

type CreateQueryOptionsProps<T> = {
  queryKey: any[];
  graphqlQuery: string;
  getVariables: () => Record<string, any>;
  options?: Partial<UseQueryOptions<T[], Error, T[], any[]>>;
};

export function createQueryOptions<T>({
  queryKey,
  graphqlQuery,
  getVariables,
  options = {},
}: CreateQueryOptionsProps<T>) {
  return queryOptions<T[], Error, T[], any[]>({
    queryKey,
    queryFn: () => fetchAllPaginatedGraphQl<T>(graphqlQuery, getVariables()),
    ...options,
  });
}
